import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useT } from "@/i18n/TranslationContext";

const LegalPage = ({ tKey }) => {
  const { t, lang, dict } = useT();
  const base = `/${lang}`;
  const page = dict[tKey] || {};

  useEffect(() => {
    document.title = `${page.title || ""} \u2014 Ecominarg`;
  }, [page.title]);

  return (
    <main className="bg-white">
      <section className="relative bg-gradient-to-b from-[#f6f4ef] to-white border-b border-[#0b2545]/10">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-16 lg:py-20">
          <Link
            to={base}
            className="inline-flex items-center gap-1.5 text-sm text-[#0b2545]/75 hover:text-[#c46a3d] font-semibold"
          >
            <ArrowLeft className="w-4 h-4" /> {t("nav.home")}
          </Link>
          <h1 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#0b2545]">
            {page.title}
          </h1>
          <p className="mt-3 text-sm font-semibold uppercase tracking-widest text-[#c46a3d]">
            {page.updated}
          </p>
          <p className="mt-5 text-base sm:text-lg text-[#0b2545]/78 leading-relaxed">
            {page.intro}
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-5 lg:px-8 py-14 lg:py-20">
        <div className="space-y-8">
          {(page.sections || []).map((s, idx) => (
            <article key={idx} className="border-l-4 border-[#c46a3d]/70 pl-5">
              <h2 className="text-xl sm:text-2xl font-bold text-[#0b2545]">{s.title}</h2>
              <p className="mt-2 text-[#0b2545]/78 leading-relaxed">{s.body}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
};

export default LegalPage;
